import ReactMarkdown from 'react-markdown';

/** Body copy for assistant markdown — keep in sync across ChatPanel, Chat, and similar surfaces. */
export const AGENT_MARKDOWN_BODY_CLASS =
    'text-sm leading-relaxed text-gray-900 [&_p]:mb-3 [&_p:last-child]:mb-0 [&_ul]:my-2 [&_ol]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5 [&_h1]:text-sm [&_h1]:font-semibold [&_h2]:text-sm [&_h2]:font-semibold [&_h3]:text-sm [&_h3]:font-semibold [&_strong]:font-semibold [&_code]:rounded [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-[13px] [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:bg-gray-50 [&_pre]:p-3 [&_pre]:text-[13px] [&_a]:text-indigo-600 [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:border-gray-200 [&_blockquote]:pl-3 [&_blockquote]:text-gray-700';

/** Human bubble text — same size as agent body for visual parity. */
export const CHAT_HUMAN_TEXT_CLASS = 'text-sm leading-relaxed text-gray-900';

/** Table / chart titles above structured blocks. */
export const CHAT_STRUCTURE_TITLE_CLASS = 'text-sm font-semibold text-gray-900 mb-2';

type AgentMarkdownProps = {
    content: string;
    className?: string;
};

/**
 * Renders assistant message markdown with consistent typography app-wide
 * (documents AI CFO, margin/cashflow panel, etc.).
 */
export default function AgentMarkdown({ content, className = '' }: AgentMarkdownProps) {
    if (!content) return null;
    return (
        <div className={`${AGENT_MARKDOWN_BODY_CLASS} ${className}`.trim()}>
            <ReactMarkdown>{content}</ReactMarkdown>
        </div>
    );
}
